import { Injectable } from '@angular/core';

@Injectable()
export class WindowRef {
    constructor() {}

    getNativeWindow() {
        return window;
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/core/components/window/window.service.ts